function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // Generate hash code from string characters
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    // Convert hash to RGB
    const value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).slice(-2);
  }
  return color;
}
const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .filter(n => n.length > 0)
    .slice(0, 2) // Take only first two parts
    .map(n => n[0])
    .join('')
    .toUpperCase();
};

export  {stringToColor,getInitials};